export const isCreatingPlan = () =>
  window.location.pathname.includes("create-plan");
export const isEditingPlan = () =>
  window.location.pathname.includes("edit-plan");
